import SvgIcon, { SvgIconProps } from "./SvgIcon";

const GroupSecondIcon: React.FC<SvgIconProps> = ({
  variant = "contained",
  ...props
}) => {
  return (
    <SvgIcon {...props}>
      {variant == "contained" ? (
        <>
          <path
            d="M9.07288 20.4845C8.06885 20.4845 7.41919 20.4845 7.41919 18.7561C7.41919 17.842 9.4183 16.002 12.4304 15.9782C15.4479 16.0099 17.4415 17.842 17.4415 18.7561C17.4415 20.4845 16.7901 20.4845 15.7879 20.4845H9.07288Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            d="M12.4314 13.3818C13.8781 13.3818 15.0508 12.209 15.0508 10.7624C15.0508 9.31575 13.8781 8.14301 12.4314 8.14301C10.9847 8.14301 9.81201 9.31575 9.81201 10.7624C9.81201 12.209 10.9847 13.3818 12.4314 13.3818Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            d="M7 11C3.83151 11.0185 2.13452 10.8307 2.13452 12.9918C2.13452 14.3363 2.81792 14.3363 3.87409 14.3363H7.9773"
            // fill="black"
          />
          <path
            d="M7 11C3.83151 11.0185 2.13452 10.8307 2.13452 12.9918C2.13452 14.3363 2.81792 14.3363 3.87409 14.3363H7.9773C7.9773 14.3363 7.11001 13.2327 7 12.5C6.84986 11.5 7 11 7 11Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18 11C20.5348 11.0185 21.9999 10.8306 21.9999 12.9918C21.9999 14.3363 21.4532 14.3363 20.6083 14.3363H17.3257"
            fill="currentColor"
          />
          <path
            d="M18 11C20.5348 11.0185 21.9999 10.8306 21.9999 12.9918C21.9999 14.3363 21.4532 14.3363 20.6083 14.3363H17.3257C17.3257 14.3363 17.8696 13.5 18 12.5C18.1304 11.5 18 11 18 11Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.02728 7.86543C7.22848 7.86543 8.20225 6.89166 8.20225 5.69046C8.20225 4.48924 7.22848 3.51547 6.02728 3.51547C4.82606 3.51547 3.85229 4.48924 3.85229 5.69046C3.85229 6.89166 4.82606 7.86543 6.02728 7.86543Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            d="M18.4914 7.86543C17.2901 7.86543 16.3164 6.89166 16.3164 5.69046C16.3164 4.48924 17.2901 3.51547 18.4914 3.51547C19.6926 3.51547 20.6664 4.48924 20.6664 5.69046C20.6664 6.89166 19.6926 7.86543 18.4914 7.86543Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
        </>
      ) : (
        <>
          <path
            d="M9.07288 20.4845C8.06885 20.4845 7.41919 20.4845 7.41919 18.7561C7.41919 17.842 9.4183 16.002 12.4304 15.9782C15.4479 16.0099 17.4415 17.842 17.4415 18.7561C17.4415 20.4845 16.7901 20.4845 15.7879 20.4845H9.07288Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="10"
            fill="white"
          />
          <path
            d="M12.4314 13.3818C13.8781 13.3818 15.0508 12.209 15.0508 10.7624C15.0508 9.31575 13.8781 8.14301 12.4314 8.14301C10.9847 8.14301 9.81201 9.31575 9.81201 10.7624C9.81201 12.209 10.9847 13.3818 12.4314 13.3818Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="10"
            fill="white"
          />
          <path
            d="M7.40593 10.8307C4.23744 10.8492 2.13452 10.8307 2.13452 12.9918C2.13452 14.3363 2.81792 14.3363 3.87409 14.3363H7.9773"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="white"
          />
          <path
            d="M17.7827 10.8307C20.3176 10.8492 21.9999 10.8307 21.9999 12.9918C21.9999 14.3363 21.4532 14.3363 20.6083 14.3363H17.3257"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="white"
          />
          <path
            d="M6.02728 7.86543C7.22848 7.86543 8.20225 6.89166 8.20225 5.69046C8.20225 4.48924 7.22848 3.51547 6.02728 3.51547C4.82606 3.51547 3.85229 4.48924 3.85229 5.69046C3.85229 6.89166 4.82606 7.86543 6.02728 7.86543Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="10"
            fill="white"
          />
          <path
            d="M18.4914 7.86543C17.2901 7.86543 16.3164 6.89166 16.3164 5.69046C16.3164 4.48924 17.2901 3.51547 18.4914 3.51547C19.6926 3.51547 20.6664 4.48924 20.6664 5.69046C20.6664 6.89166 19.6926 7.86543 18.4914 7.86543Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="10"
            fill="white"
          />
        </>
      )}
    </SvgIcon>
  );
};

export default GroupSecondIcon;
